<template>
  <section>
    <HeroSection headName="Dashboard" :searchBar="true" :addButton="false">
      <div class="searchbar__wrap">
        <FormSelect label="Usuário" :required="false" :dataList="usersListData" v-model:modelValue="filters.usuario" classPrefix="searchbar" v-if="isUserAdmin()" />
      </div>
    </HeroSection>

    <div class="container">
      <DataLoading rows="6" height="120px" v-if="loading"/>

      <div class="dcontent">
        <div class="tlist" v-for="(info, index) in dboxes" :key="index" v-show="!loading">
          <h3 class="tlist__name">
            <font-awesome-icon :icon="['fa', info.icon ]" />

            {{ info.title }}
          </h3>
          <ul class="dlist">
            <li class="ditem" v-for="(item, i) in info.data" :key="i">
              <div class="dbox" :style="`border-left: 6px solid ${info.color}`">
                <div class="dhead">
                  <font-awesome-icon :icon="['fa', 'clock-rotate-left']" />

                  {{ item.title }}
                </div>

                <div class="dbody">
                  <span class="dnum">
                    {{ item.value }}
                  </span>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

import DataLoading from '@components/_partials/DataLoading.vue';
import HeroSection from '@components/_partials/HeroSection.vue';
import FormSelect from '@components/_form/FormSelect.vue';
import { userTypes } from '@helpers/constants';
import usuario from '@services/usuario';
import storage from 'storage';
import dashboard from '@services/dashboard';

export default {
  components: {
    DataLoading,
    HeroSection,
    FormSelect
  },
  data() {
    return {
      loading: false,
      dboxes: [],
      model: {},
      filters: {},
      usersListData: []
    }
  },
  methods: {
    userTypes,
    initLoad(third_token = false) {
      const _this = this;
      const user = _this.getUser();

      const infoData = [
        { key: 'sendedMessages', icon: 'infinity', color: '#13678A', title: 'Mensagens Totais' },
        { key: 'receivedMessages', icon: 'inbox', color: '#A6BC09', title: 'Mensagens Recebidas (inbox)' },
        { key: 'openMessages', icon: 'envelope-open', color: '#0099DD', title: 'Mensagens Abertas (apenas)' },
        { key: 'clickMessages', icon: 'computer-mouse', color: '#9326FC', title: 'Mensagens Clicadas' },
        { key: 'contactsInBlackList', icon: 'skull-crossbones', color: '#8C0F0F', title: 'Mensagens em Blacklist' }
      ];

      const user_token = third_token !== false ? third_token : user.user_token;
      _this.loading = true;

      dashboard.details(user_token).then(res => {
        if(typeof res !== 'undefined' && res.success) {
          const { data } = res;

          const processedData = infoData.map(info => {
            const apiItem = data.find(item => item[info.key]);

            let dataItens = [];
            let dataItem =  apiItem[info.key];

            dataItens.push({ title: 'Tudo', value: dataItem.all.toLocaleString('de-DE') });
            dataItens.push({ title: 'Últimos 30 dias', value: dataItem.last30days.toLocaleString('de-DE') });
            dataItens.push({ title: 'Últimos 15 dias', value: dataItem.last15days.toLocaleString('de-DE') });
            dataItens.push({ title: 'Últimos 7 dias', value: dataItem.last7days.toLocaleString('de-DE') });
            dataItens.push({ title: 'Ontem', value: dataItem.yesterday.toLocaleString('de-DE') });
            dataItens.push({ title: 'Hoje', value: dataItem.today.toLocaleString('de-DE') });

            const { title, icon, color } = info;

            return {
              title,
              color,
              icon,
              data: dataItens
            };
          });

          _this.dboxes = processedData;
          _this.loading = false;
        }
      })
    },
    getUser() {
      const local = 'mail4fly--user';
      const user = storage.get(local);
      return user;
    },
    isUserAdmin() {
      const user = this.getUser();
      return user && user.role === 'admin' ? user : false;
    },
    usersList() {
      const _this = this;

      if(!_this.isUserAdmin()) return false;

      usuario.retrieve().then((res) => {
        if(typeof res !== 'undefined' && res.success) {
          const users = res.data.docs.map(item => ({
            label: `${item.senderName} - ${userTypes(item.senderAwsConfig, 'label')}`,
            value: item.senderAuthToken
          }));

          if(_this.isUserAdmin()) {
            _this.filters.usuario = _this.getUser().user_token;
          }

          _this.usersListData = users;
        }
      });
    }
  },
  watch: {
    'filters.usuario'(usuario) {
      this.initLoad(usuario);
    }
  },
  mounted(){
    this.usersList();
    this.initLoad();
  }
};

</script>
